import download from './download';
var path = '/authority';
var authority = function (url) { return function () { return ({
    download: download(url + path),
}); }; };
export default authority;
